import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import translations from '../data/translations';

export default function Footer() {
  const { lang } = useLanguage();
  const t = translations.footer[lang];
  const navT = translations.nav[lang];
  const servT = translations.services[lang];

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="relative bg-enbi-navy border-t border-white/10">
      {/* Gold top line */}
      <div className="h-[3px] bg-enbi-gold" style={{ clipPath: 'polygon(0 0, 45% 0, 40% 100%, 0 100%)' }} />

      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo-monogram-white.png" alt="ENBI" className="w-10 h-10" />
              <div>
                <div className="text-white font-outfit font-bold tracking-wider text-lg">ENBI MARKETING</div>
                <div className="text-enbi-gold text-[10px] tracking-[0.25em] uppercase">{t.tagline}</div>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-sm">
              {t.desc}
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3">
            <h4 className="font-outfit text-white text-xs tracking-[0.2em] uppercase font-semibold mb-6">{t.quickLinks}</h4>
            <div className="space-y-3">
              {[
                { id: 'about', label: navT.about },
                { id: 'services', label: navT.services },
                { id: 'benefits', label: navT.benefits },
                { id: 'references', label: navT.references },
                { id: 'contact', label: navT.contact },
              ].map(l => (
                <button
                  key={l.id}
                  onClick={() => scrollTo(l.id)}
                  className="block text-white/50 text-sm hover:text-enbi-gold transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-4">
            <h4 className="font-outfit text-white text-xs tracking-[0.2em] uppercase font-semibold mb-6">{t.servicesTitle}</h4>
            <div className="space-y-3">
              {servT.items.slice(0, 5).map((item, i) => (
                <p key={i} className="text-white/50 text-sm">{item.title}</p>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs tracking-wider">
            &copy; {new Date().getFullYear()} ENBI Marketing. {t.rights}
          </p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-white/30 text-xs hover:text-enbi-gold transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="text-white/30 text-xs hover:text-enbi-gold transition-colors">{lang === 'de' ? 'Datenschutz' : 'Privacy Policy'}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
